import React from 'react';
import { FormattedMessage } from 'react-intl';
import { format } from '../lib/money';

export default props => (
  <p className="share-info">
    <FormattedMessage
      id="splitPurchaseProjection.text"
      defaultMessage="Each will pay {amount}, you can edit how you split at any time."
      values={{
        amount: format(props.shareAmount)
      }}
    />
  </p>
);



// WEBPACK FOOTER //
// ./src/desktop/components/split-purchase-projection.js